import { render } from "./StoreFeaturedProducts.vue?vue&type=template&id=1d8a04ad&scoped=true"
import script from "./StoreFeaturedProducts.vue?vue&type=script&lang=js"
export * from "./StoreFeaturedProducts.vue?vue&type=script&lang=js"

import "./StoreFeaturedProducts.vue?vue&type=style&index=0&id=1d8a04ad&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8a04ad"]])

export default __exports__